import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faPercent } from '@fortawesome/free-solid-svg-icons';
import Button from './Button';
import { Form, FormInput, FormButton } from './Form';

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: var(--spacing-md);
`;

const PopupContainer = styled(motion.div)`
  background-color: white;
  border-radius: var(--border-radius-lg);
  width: 100%;
  max-width: 500px;
  overflow: hidden;
  position: relative;
  box-shadow: var(--shadow-lg);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.2rem;
  color: white;
  z-index: 5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  
  &:hover {
    opacity: 0.8;
  }
`;

const PopupHeader = styled.div`
  background-color: var(--color-secondary);
  color: white;
  padding: var(--spacing-lg) var(--spacing-md);
  position: relative;
`;

const PromoIcon = styled.div`
  position: absolute;
  top: -20px;
  left: -20px;
  width: 80px;
  height: 80px;
  background-color: var(--color-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 2rem;
  transform: rotate(-20deg);
  box-shadow: var(--shadow-md);
`;

const PromoTitle = styled.h2`
  margin-left: var(--spacing-lg);
  font-size: 1.5rem;
  margin-bottom: var(--spacing-xs);
`;

const PromoSubtitle = styled.p`
  margin-left: var(--spacing-lg);
  margin-bottom: 0;
  font-size: 1.1rem;
`;

const PopupContent = styled.div`
  padding: var(--spacing-xl) var(--spacing-lg);
`;

const SuccessMessage = styled.div`
  text-align: center;
  padding: var(--spacing-lg);
  
  h3 {
    color: var(--color-primary);
    margin-bottom: var(--spacing-md);
  }
  
  p {
    margin-bottom: var(--spacing-md);
  }
`;

const PromoPopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });
  
  const [success, setSuccess] = useState(false);
  
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Здесь можно добавить логику для отправки данных
    console.log('Отправка формы:', formData);
    setSuccess(true);
  };
  
  return (
    <AnimatePresence>
      <Overlay
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <PopupContainer
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.8, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 25 }}
          onClick={(e) => e.stopPropagation()}
        >
          <CloseButton onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </CloseButton>
          
          <PopupHeader>
            <PromoIcon>
              <FontAwesomeIcon icon={faPercent} />
            </PromoIcon>
            <PromoTitle>Скидка 10% на первый заказ!</PromoTitle>
            <PromoSubtitle>Оставьте заявку прямо сейчас</PromoSubtitle>
          </PopupHeader>
          
          <PopupContent>
            {success ? (
              <SuccessMessage>
                <h3>Спасибо за заявку!</h3>
                <p>Мы свяжемся с вами в ближайшее время и расскажем, как получить скидку.</p>
                <Button 
                  variant={'contained'} 
                  size={'medium'}
                  onClick={onClose}
                >
                  Отлично!
                </Button>
              </SuccessMessage>
            ) : (
              <Form onSubmit={handleSubmit}>
                <FormInput
                  id="promo-name"
                  name="name"
                  label="Ваше имя"
                  placeholder="Введите ваше имя"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
                
                <FormInput
                  id="promo-phone"
                  name="phone"
                  label="Номер телефона"
                  placeholder="+7 (___) ___-__-__"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
                
                <FormInput
                  id="promo-email"
                  name="email"
                  type="email"
                  label="Email"
                  placeholder="example@domain.com"
                  value={formData.email}
                  onChange={handleChange}
                />
                
                <FormButton 
                  type="submit" 
                  variant={'outlined'}
                  fullWidth
                >
                  Получить скидку
                </FormButton>
              </Form>
            )}
          </PopupContent>
        </PopupContainer>
      </Overlay>
    </AnimatePresence>
  );
};

export default PromoPopup; 